import React from 'react'
import { useTranslation } from 'react-i18next'

import { Tabs as MaterialTabs, Tab } from '@mui/material'

import { SectionHeader } from 'components/common'
import TabPanel from 'components/core/Acquiring/AcquiringTabs/components/TabPanel'

const Tabs: React.FC<TabsProps> = ({ tabs, classes, currentTabIndex, onTabChange }) => {
    const { t } = useTranslation()

    return (
        <>
            <SectionHeader>{t('Acquiring.PageTitle')}</SectionHeader>
            <MaterialTabs value={currentTabIndex} onChange={onTabChange} textColor="primary" indicatorColor="primary" variant="scrollable">
                {tabs?.map(({ label, disabled, hidden }, i) => (
                    <Tab
                        label={t(label)}
                        classes={{ root: classes.tabsStyles, selected: classes.tabSelected }}
                        key={i}
                        style={{ display: hidden ? 'none' : 'block' }}
                        disabled={disabled}
                    />
                ))}
            </MaterialTabs>
            {tabs?.map(({ Component }, i) => (
                <TabPanel value={currentTabIndex} index={i} key={i}>
                    {!!Component && <Component />}
                </TabPanel>
            ))}
        </>
    )
}

export default Tabs
